import uaParser from 'ua-parser-js';
export const getWebUser = () => {
    const browserInfo = new uaParser();
    const browser = browserInfo.getBrowser();
    const browserName = `${browser.name} ${browser.version}`.trim();
    const device = browserInfo.getDevice();
    const deviceName = `${device.vendor} ${device.type}`.trim();
    const os = browserInfo.getOS();
    const osName = `${os.name} ${os.version}`.trim();
    return {
        language: navigator.language.split(',')[0],
        locales: navigator.languages,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        browser: browser.name ? browserName : undefined,
        device: device.type ? deviceName : undefined,
        platform: os.name ? osName : undefined,
    };
};
